// PIXI plugins
import 'pixi.js/math-extras';
import 'pixi.js/unsafe-eval';

/**
 * This function applies global Pixi.js settings we need
 */
export function ConfigurePixiSettings(): void {
	// Nothing here for now

	// Debug utilities
	// DebugInitResourceRetentionMonitor();
}
